import * as angular from 'angular';

import template from './dialog-prompt-modal.html';

const dialogPromptModalDirective = function (Modal) {
  return {
    restrict: 'A',
    link: function ($scope: any, $elem: angular.IAugmentedJQuery) {
      const modal = Modal.open(
        {
          title: $scope.dialogPromptModalTitle,
          text: $scope.dialogPromptModalContent,
        },
        {
          template: template,
        }
      );
      $scope.$on('$destroy', () => $elem.off('click.confirm'));
    },
    scope: {
      dialogPromptModalTitle: '@',
      dialogPromptModalContent: '@',
    },
  };
};

dialogPromptModalDirective.$inject = ['ModalService'];
angular.module('mode.components').directive('dialogPromptModal', dialogPromptModalDirective);
